import * as yup from 'yup';
import { INVALID_EMAIL_MSG } from '../../validation';

export const schema = yup.object().shape({
  firstName: yup.string().required('name is a required field'),
  email: yup
    .string()
    .required('email is a required field')
    .email(INVALID_EMAIL_MSG),
});

export const emailOnlySchema = yup.object().shape({
  email: yup
    .string()
    .required('email is a required field')
    .email(INVALID_EMAIL_MSG),
});
